// extracted by mini-css-extract-plugin
export default {"HeroSectionText":"HeroSection_HeroSectionText__xXpEJ","HeroSectionContainer":"HeroSection_HeroSectionContainer__3LzlF","HeroSectionImage":"HeroSection_HeroSectionImage__+zo3S"};